import React from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'

import UserColumn from './components/UserColumn'
import RecentsColumn from './components/RecentsColumn'

import FavoritesColumn from './components/FavoritesColumn'
import useSavedValue from '@SonarCX/hooks/useSavedValue'

import useStyles from './styles'

export enum View {
  Recent = 'recent',
  Favorite = 'favorite'
}

const HomeTab: React.FC = () => {
  const [view, setView] = useSavedValue({
    key: 'hometab-view',
    defaultValue: '"recent"'
  })
  const { user, env, loaded: envLoaded } = useEnvironment()

  const classes = useStyles()

  return (
    <div className={classes.root}>
      {envLoaded && (
        <>
          <UserColumn user={user} view={view as View} setView={setView} />
          <div>
            <h4 className={classes.header}>Welcome, {user.name}</h4>
            <AnimatePresence mode='wait'>
              <motion.div
                key={view.toString()}
                initial={{ y: 10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -10, opacity: 0 }}
                transition={{ duration: 0.2 }}
              >
                {view === View.Recent && (
                  <RecentsColumn user={user} env={env} />
                )}

                {view === View.Favorite && <FavoritesColumn />}
              </motion.div>
            </AnimatePresence>
          </div>
        </>
      )}
      {/* hide for now to see how it goes. sadge */}
      {/* <div className={classes.fade}></div> */}
    </div>
  )
}

export default HomeTab
